/**
 * @copyright Copyright 2016 The MathWorks, Inc.
 * @description ContentWidget is a module which used to render content for a dialog
 * @module mw-dialogs/view/ContentWidget
 */
define([
    "dojo/_base/lang",
    "dojo/dom-attr",
    "dojo/dom-construct",
    "dojo/dom-style",
    "mw-dialogs/utils/mixinDijitLifecycleMethods"
], function (lang, domAttr, domConstruct, domStyle, mixinDijitLifecycleMethods) {

    /**
     * @class contentWidget
     * @description Creates a content widget in the dialog content area
     * @param {Object} [args] - argument object
     * @param {Object | String} [args.widget] - The object in the content. Could either be a widget,
     * dijit, message string or DOM element.
     * @param {domNode} [args.contentArea] - DOM Node of dialog content area
     * @private
     */
    class contentWidget {
        constructor(args) {
            this.widget = args.widget;
            this.contentArea = args.contentArea;
            mixinDijitLifecycleMethods(this);
            this._addWidget(this.widget);
        }

        _addWidget(widget) {
            if (lang.isString(widget)) {
                // If content is a message
                let message = domConstruct.create("div");
                message.className = "mwContentMessage";
                domAttr.set(message, "textContent", widget);
                domAttr.set(message, "data-test-id", "dialog-content-widget");
                domStyle.set(message, "whiteSpace", "pre-line");
                domConstruct.place(message, this.contentArea, "first");
                this.domNode = message;
            } else if (lang.isFunction(widget.placeAt)) {
                // If content is a widget/dijit object
                domAttr.set(widget.domNode, "data-test-id", "dialog-content-widget");
                widget.placeAt(this.contentArea, "first");
                this.domNode = widget.domNode;
            } else {
                // If content is a DOM element
                domAttr.set(widget, "data-test-id", "dialog-content-widget");
                domConstruct.place(widget, this.contentArea, "first");
                this.domNode = widget;
            }

        }
    }

    return contentWidget;
});
